import { Button, Result, Typography } from 'antd';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

const { Paragraph, Text } = Typography;

/**
 * Error boundary específico para React Router v6
 * Usa useRouteError() para capturar errores de navegación
 */
const RouteErrorBoundary = () => {
  const error = useRouteError();
  const isDev = import.meta.env.DEV;

  let title = 'Algo salió mal';
  let description = 'Lo sentimos, ha ocurrido un error inesperado.';
  let status: '403' | '404' | '500' = '500';

  // Determinar tipo de error
  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      title = 'Página no encontrada';
      description = 'La página que buscas no existe.';
      status = '404';
    } else if (error.status === 403) {
      title = 'Acceso denegado';
      description = 'No tienes permisos para acceder a esta página.';
      status = '403';
    }
  }

  const handleGoHome = () => {
    window.location.href = '/home';
  };

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="flex items-center justify-center min-h-screen w-full">
      <Result
        status={status}
        title={title}
        subTitle={description}
        extra={[
          <Button type="primary" key="home" onClick={handleGoHome}>
            Ir al Inicio
          </Button>,
          <Button key="reload" onClick={handleReload}>
            Recargar Página
          </Button>,
        ]}
      >
        {isDev && error instanceof Error && (
          <div className="mt-4 text-left max-w-screen-2xl mx-auto">
            <Paragraph>
              <Text strong className="text-red-600">
                Error: {error.message}
              </Text>
            </Paragraph>
            {error.stack && (
              <Paragraph>
                <pre className="p-4 rounded text-xs overflow-auto max-h-60">{error.stack}</pre>
              </Paragraph>
            )}
          </div>
        )}
      </Result>
    </div>
  );
};

export default RouteErrorBoundary;
